import { render } from "./Home.vue?vue&type=template&id=06db190d"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=06db190d&lang=css"
script.render = render

export default script